import { Suspense, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getCurrentUser } from "./actions/userActions";
import "./App.css";
import { Loader } from "./modules/shared/components/Loader/Loader";
import Router from "./routes";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCurrentUser());
  }, []);
  return (
    <Suspense fallback={<Loader />}>
      <Router />
    </Suspense>
  );
}

export default App;
